'use strict';
/*!
* main.js
*/

window.app = {};

// 必ずjQueryを最初に
const jQuery = require('jquery');
window.$ = window.jQuery = jQuery;

// 全部requireに統一
const _ = require('lodash');
const closest = require('./libs/closest');
const { on, off } = require('./libs/eventtoggle');

require('./libs/viewport');
require('./libs/swiper.min');   // トップFV（Top.js）と画像スライダーブロック（PosSlide.js）
require('./libs/modaal.min');   // ヘッダー「受講者ログイン」のログインモーダル（Header.js）

// 以下は読み込んでいたが呼び出しが無かったので外した（バンドル -66.5KB）。
//   jquery.validate / 日本語 … 使うのは Contact.js だけで、その Contact.js が
//                               App.js でコメントアウト済み。フォームの検証は
//                               Contact Form 7 が自前で持っている
//   perfect-scrollbar        … .js-perfectScrollbar を持つ要素が0件
//   jquery.ripples           … ripples() の呼び出しが無い
//   imagesloaded             … window に入れているだけで参照が無い
//   jquery.easing            … Config.ease.tween は 'linear'（jQuery標準）。
//                               InertialScroll は自前の easeOutQuart を使っている

const App = require('./components/App').default;
app = new App();
app.render();